<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/bg32.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h1 class="title">Services</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="about-description text-center">
                <div class="features-3">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                <h2 class="title">Services We Provide</h2>
                              
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons business_globe"></i>
                                    </div>
                                    <h4 class="info-title">Online Payment Services</h4>
                                    <p class="description"></p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons tech_mobile"></i>
                                    </div>
                                    <h4 class="info-title">Mobile Payment App</h4>
                                    <p class="description"></p>
                                </div>
                            </div>
                             <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons business_bank"></i>
                                    </div>
                                    <h4 class="info-title">Bank Transfer</h4>
                                    <p class="description"></p>
                                </div>
                            </div>
                        </div>
                             <div class="row">
                            <div class="col-md-8 mr-auto ml-auto mt-5">
                                <h2 class="title">Why Pagarstar</h2>
                              
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons ui-2_like"></i>
                                    </div>
                                    <h4 class="info-title">Client Centered</h4>
                                    <p>Customers' Satisfaction is our No. 1 priority. </p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons objects_key-25"></i>
                                    </div>
                                    <h4 class="info-title">Secure</h4>
                                    <p class="description">SSL certificates to protect transfer of Data. Encrypted SHA-2 and 2048-bit are compatible with browsers.</p>
                                </div>
                            </div>
                             <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons ui-2_settings-90"></i>
                                    </div>
                                    <h4 class="info-title">Back-up</h4>
                                    <p class="description">In case of Main server maintenance, we have cloud-base back-up server to keep your business running.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons sport_user-run"></i>
                                    </div>
                                    <h4 class="info-title">Quick</h4>
                                    <p>Real Time Transaction where you submit request, customer can pick up the money right away.</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons gestures_tap-01"></i>
                                    </div>
                                    <h4 class="info-title">One-Stop Services</h4>
                                    <p class="description">Once connected, all services are ready!</p>
                                </div>
                            </div>
                             <div class="col-md-4">
                                <div class="info info-hover">
                                    <div class="icon icon-info icon-circle">
                                        <i class="now-ui-icons design_vector"></i>
                                    </div>
                                    <h4 class="info-title">Integration with Efficiency</h4>
                                    <p class="description">Take 10-14 business day to integrate your business with our server and all services are online!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="features-6">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">PagarStar Mobile APP</h2>
              <h4 class="description">All in one APP helps you to process payment easy, safe and fast. Anytime and Anywhere.</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="now-ui-icons business_money-coins"></i>
                </div>
                <div class="description">
                  <h5 class="info-title">Pay Bills</h5>
                  <p>You can pay different bills anytime, anywhere.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="now-ui-icons arrows-1_refresh-69"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Fund Transfer</h4>
                  <p>Fund Transfer instantly without paying any transaction fee.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="now-ui-icons tech_laptop"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Fund Receive</h4>
                  <p>Receive fund easily by few clicks.</p>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-first">
              <div class="phone-container">
                <img src="img/iphone.png" />
              </div>
            </div>
            <div class="col-md-4 order-last">
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="now-ui-icons shopping_cart-simple"></i>
                </div>
                <div class="description">
                  <h5 class="info-title">Shopping</h5>
                  <p>Shopping with your phone.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="now-ui-icons objects_spaceship"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Topping up</h4>
                  <p>Topping your account balance with few steps only.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="now-ui-icons files_single-copy-04"></i>
                </div>
                <div class="description">
                  <h4 class="info-title">Lending</h4>
                  <p>Wide selection of banks and customized financial solution for you.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            <!-- <div class="separator-line separator-info"></div>
            <div class="projects-5">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5 ml-auto">
                            <card type="background" raised class="card-background-product"
                                  style="background-image: url('img/project8.jpg')">
                                <h2 class="card-title">Online Payment Services</h2>
                               
                            
                            </card>
                        </div>
                        <div class="col-md-5 mr-auto mt-3">
                            <info-section type="info"
                                          icon="now-ui-icons business_bulb-63"
                                          title="Easy"
                                          description="Easy to Setup, Easy to Use, Easy to Monitor"
                            />

                            <info-section type="info"
                                          icon="now-ui-icons objects_key-25"
                                          title="Safe"
                                          description="All card numbers are encrypted on disk with AES-256. Decryption keys are stored on separate machines."
                            />

                            <info-section type="info"
                                          icon="now-ui-icons business_globe"
                                          title="Wide variety of payment method"
                                          description="including VISA Master and different well recognized payment method"
                            />
                        </div>
                    </div>
                    <hr/>
                    
                             <div class="row">
                        <div class="col-md-5 ml-auto">
                            <card type="background" raised class="card-background-product"
                                  style="background-image: url('img/project9.jpg')">
                                <h2 class="card-title">Mobile Payment App</h2>
                               
                            
                            </card>
                        </div>
                          <div class="col-md-5 mr-auto mt-5">
                            <info-section type="info"
                                          icon="now-ui-icons users_single-02"
                                          title="Professional"
                                          description="Daily Transaction easy, safe and quick"
                            />

                            <info-section type="info"
                                          icon="now-ui-icons business_money-coins"
                                          title="Customization"
                                          description="Transfer of fund through different method with few clicks"
                            />

                           
                        </div>
                    </div>
                    
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'

  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          speciality: ''
        }
      }
    }
  }
</script>
<style>
</style>
